import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./ServiceDescriptionHeader.css";

const decodeHTML = (html) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};

const ServiceDescriptionHeader = () => {
  const { id } = useParams(); // Get the service ID from the URL
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // useEffect(() => {
  //   const fetchServices = async () => {
  //     try {
  //       const response = await axios.get(`${baseURl}/api/v1/service/`);

  //       if (response.data.success && Array.isArray(response.data.data)) {
  //         const services = response.data.data.map((service) => ({
  //           _id: service._id,
  //           title: decodeHTML(service.title),
  //         }));

  //         // Find the service that matches the ID from the URL
  //         const selectedService = services.find((s) => s._id === id);
  //         if (selectedService) {
  //           setService(selectedService);
  //         } else {
  //           setError("Service not found.");
  //         }
  //       } else {
  //         throw new Error("Invalid API response format");
  //       }
  //     } catch (err) {
  //       console.error("Error fetching service:", err);
  //       setError("Failed to fetch service.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchServices();
  // }, [id]);

  return (
    <div
      className="service-header1"
    >
      <div className="overlay23">
        {/* {loading ? (
          <h1>Loading...</h1>
        ) : error ? (
          <h1>Services</h1>
        ) : (
          <h1>{service?.title || "Services"}</h1>
        )} */}
        {/* <span className="arrow">&#x25BC;</span> */}
      </div>
    </div>
  );
};

export default ServiceDescriptionHeader;